module.exports = __webpack_public_path__ + "img/utility_stopped.6c7ae657.svg";